export const apiBase = () =>
  process.env.NODE_ENV === "development"
    ? "/api/v1/"
    : "https://api.fortheday.org/api/v1/";
